import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { useCallback, useImperativeHandle, useRef, useState } from 'react';
import { Portal } from '../root-layout/Portal';
import { RootLayoutProvider } from '../root-layout/RootLayoutContext';
import ModalCloseButton from './ModalCloseButton';
import { useDialog } from './useDialog';
const DialogRoot = styled.dialog `
  background-color: transparent;

  ::backdrop {
    background-color: rgba(113, 113, 122, 0.75);
  }
`;
const DialogContents = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: white;
  border-width: 1px;
  border-color: transparent;
  border-radius: 0.5rem;
  box-shadow: 0 0 0 0, 0 0px 16px rgba(0, 0, 0, 0.3);
`;
const ModalHeaderStyled = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px 10px 20px;
  border-bottom: 2px solid rgb(247, 247, 247);
`;
const ModalBodyStyled = styled.div `
  display: flex;
  flex: 1 1 0%;
  overflow-y: auto;
`;
const ModalFooterStyled = styled.div `
  border-top: 2px solid rgb(247, 247, 247);
  padding: 10px 20px 10px 20px;
`;
export function Modal(props) {
    const { isOpen, onRequestClose, hasCloseButton = true, requestCloseOnBackdrop = true, requestCloseOnEsc = true, children, width, maxWidth, height, } = props;
    const dialogRef = useRef(null);
    const dialogProps = useDialog({
        dialogRef,
        isOpen,
        requestCloseOnEsc,
        requestCloseOnBackdrop,
        onRequestClose,
    });
    const [portalDomNode, setPortalDomNode] = useState(null);
    const dialogCallbackRef = useCallback((node) => {
        setPortalDomNode(node);
    }, []);
    useImperativeHandle(dialogCallbackRef, () => dialogRef.current);
    if (!isOpen) {
        return null;
    }
    return (_jsx(Portal, { children: _jsx(DialogRoot, { ...dialogProps, ref: dialogRef, children: _jsx(RootLayoutProvider, { innerRef: portalDomNode, children: _jsxs(DialogContents, { style: {
                        maxWidth,
                        height: height || 'max-content',
                        width: width || '100%',
                    }, children: [children, hasCloseButton && _jsx(ModalCloseButton, { onClick: onRequestClose })] }) }) }) }));
}
Modal.Header = function ModalHeader(props) {
    return _jsx(ModalHeaderStyled, { children: props.children });
};
Modal.Body = function ModalBody(props) {
    return _jsx(ModalBodyStyled, { children: props.children });
};
Modal.Footer = function ModalFooter(props) {
    return _jsx(ModalFooterStyled, { children: props.children });
};
//# sourceMappingURL=Modal.js.map